import { useCallback, useRef, useState } from 'react';
import type {
  LayoutChangeEvent,
  NativeScrollEvent,
  NativeSyntheticEvent,
  ScrollView,
} from 'react-native';

export const useScrollSync = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const contentRef = useRef<ScrollView>(null);
  const sideMenuRef = useRef<ScrollView>(null);
  const sectionOffsets = useRef<number[]>([]);
  const isUserScrolling = useRef(true);

  const handleSectionLayout = useCallback(
    (index: number) => (event: LayoutChangeEvent) => {
      sectionOffsets.current[index] = event.nativeEvent.layout.y;
    },
    [],
  );

  const handleContentScroll = useCallback(
    (event: NativeSyntheticEvent<NativeScrollEvent>) => {
      if (!isUserScrolling.current) return;

      const offsetY = event.nativeEvent.contentOffset.y;
      const offsets = sectionOffsets.current;

      let currentIndex = 0;
      for (let i = offsets.length - 1; i >= 0; i--) {
        if (offsets[i] != null && offsetY >= offsets[i] - 50) {
          currentIndex = i;
          break;
        }
      }

      if (currentIndex !== activeIndex) {
        setActiveIndex(currentIndex);
      }
    },
    [activeIndex],
  );

  const handleMenuPress = useCallback((index: number) => {
    setActiveIndex(index);
    isUserScrolling.current = false;

    const targetOffset = sectionOffsets.current[index];
    if (targetOffset != null) {
      contentRef.current?.scrollTo({ y: targetOffset, animated: true });
    }

    setTimeout(() => {
      isUserScrolling.current = true;
    }, 500);
  }, []);

  return {
    activeIndex,
    contentRef,
    sideMenuRef,
    handleSectionLayout,
    handleContentScroll,
    handleMenuPress,
  };
};
